module.exports = __webpack_public_path__ + "static/media/lohono-infinity-logo-light-lg.70c70a0a.svg";